import { layoutTypeState } from '@atom/setting/homepageSet';
import { LAYOUT_TYPE_VALUE } from '@typings/setting/layoutType';
import React from 'react';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import styled, { css } from 'styled-components';
import { versionUpdateData } from '../versionUpdateList';
import { versionUpdateModalState } from '@atom/setting/versionUpdate';
import { APP_VERSION } from '@constants/appVersion';

const footerLayoutTypeMap = {
  topType: css``,
  leftType: css`
    /* max-width: 1280px;
    padding: 0 12px 0 calc(220px + 12px); */
  `,
  hamburgerType: css``,
  tabsType: css``,
};

const FooterContainer = styled.footer.withConfig({
  shouldForwardProp: (prop: string) => prop !== 'layoutType' && prop !== '$isCompact',
}) <{ layoutType?: LAYOUT_TYPE_VALUE; $isCompact?: boolean }>`
  width: 100%;
  padding: ${({ $isCompact }) => ($isCompact ? '12px' : '10px 0')};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px ${({ layoutType }) => layoutType && footerLayoutTypeMap[layoutType]};
  line-height: 1.5;
  color: var(--subTextColor);
`;

const FooterInfo = styled.p.withConfig({
  shouldForwardProp: (prop: string) => prop !== '$isCompact',
}) <{ $isCompact?: boolean }>`
  padding: 4px 0;
  font-size: ${({ $isCompact }) => ($isCompact ? '10px' : '11px')};
  opacity: ${({ $isCompact }) => ($isCompact ? 0.8 : 1)};

  a {
    text-decoration: underline;
  }

  @media (max-width: 480px) {
    text-align: center;
  }
`;

type ServiceFooterProps = {
  variant?: 'full' | 'compact';
};

function ServiceFooter({ variant = 'full' }: ServiceFooterProps) {
  const layoutType = useRecoilValue(layoutTypeState);
  const setShowVersionModal = useSetRecoilState(versionUpdateModalState);

  // 현재 버전 데이터 확인
  const currentVersionData = versionUpdateData.find(
    (data) => data.version === APP_VERSION,
  );

  // 버전 버튼 클릭 (모달 열기)
  const handleVersionButtonClick = () => {
    setShowVersionModal((prev) => !prev);
  };

  const isCompact = variant === 'compact';

  return (
    <FooterContainer layoutType={layoutType} $isCompact={isCompact}>
      <FooterInfo $isCompact={isCompact}>
        <strong>
          {!isCompact && (
            <>
              ©
              <a
                href="https://twitter.com/moogongan"
                target="_blank"
                rel="noopener noreferrer"
              >
                moogongan
              </a>
              . All Rights Reserved&nbsp; | &nbsp;
            </>
          )}
          v.{APP_VERSION}
          &nbsp; | &nbsp;
          <a
            href="https://moogongan-guide.notion.site/"
            target="_blank"
            rel="noopener noreferrer"
          >
            이용 가이드
          </a>
          &nbsp; | &nbsp;
          <a
            href="https://moogongan-update.notion.site/"
            target="_blank"
            rel="noopener noreferrer"
          >
            업데이트 내역
          </a>
          {!isCompact && currentVersionData && (
            <>
              &nbsp; | &nbsp;
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handleVersionButtonClick();
                }}
                style={{ cursor: 'pointer' }}
              >
                현재 버전 안내
              </a>
            </>
          )}
        </strong>
      </FooterInfo>
    </FooterContainer>
  );
}

export default React.memo(ServiceFooter);
